// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingModal_container__3KAHW","label":"PendingModal_label__3FJRG text_header-2__1yKAy","actions":"PendingModal_actions__2Cx-F"};